module.exports = __webpack_public_path__ + "static/media/mobile_nbccom_video.6f44a19f.png";